import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import useMiniCard from 'hooks/useMiniCard';
import stringifyLongNumber from 'utils/stringifyLongNumber';
import nbspier from 'ati-utils/nbspier';
import cn from 'classnames';
import { PriceStyles } from './PriceStyles';

const Price: FC = observer(() => {
  const {
    dictionariesStore: { period_types },
  } = useStores();

  const {
    data: {
      advert: {
        price,
        formattedPrice,
        isRent,
        isPurchase,
        periodType,
        isContractPrice,
        isHighlighted,
      },
    },
    display: { isHovered },
  } = useMiniCard();

  const periodTypeName = (periodType && period_types[periodType]) || '';

  const renderRentPrice = () => {
    if (isContractPrice) return <b className="price">договорная</b>;
    let strPrice = formattedPrice;
    let strCurrency = 'руб';
    if (price > 999999) {
      const [shortPrice, shortCurrency] = stringifyLongNumber(price, strCurrency);
      strPrice = shortPrice;
      strCurrency = shortCurrency.replace(/\s/, '');
    }
    return (
      <>
        <b className="price">{strPrice}</b>
        <span className="currency">
          &nbsp;{strCurrency}/{nbspier(periodTypeName)}
        </span>
      </>
    );
  };

  const renderSalePrice = () => (
    <>
      <b className="price">{formattedPrice}</b>
      <span className="currency">&nbsp;руб</span>
    </>
  );

  const renderPurchasePrice = () => (
    <>
      <b className="price">до {formattedPrice}</b>
      <span className="currency">&nbsp;руб</span>
    </>
  );

  const renderPrice = () => {
    if (isRent) return renderRentPrice();
    if (isPurchase) return renderPurchasePrice();
    return renderSalePrice();
  };

  return (
    <PriceStyles className={cn(isHighlighted && 'highlighted', isHovered && 'hovered')}>
      {renderPrice()}
    </PriceStyles>
  );
});

export default Price;
